export default{
  getMenu: () => {
    let user_cnhu = localStorage.getItem('user_cnhu')
    let user = JSON.parse(user_cnhu)
    const grant = user.grant
    let menus = []
    if (grant.dashboard == true){
      menus.push({
        url: "/",
        name: "Tableau de bord",
        slug: "dashobard",
        icon: "HomeIcon",
      })
    }
    let admin_menus = {}
    if (grant.payments == true || grant.validate == true || grant.specialities.list == true
      || grant.specialities.create == true || grant.specialities.update == true || grant.specialities.delete == true
      || grant.praticiens.list == true || grant.praticiens.create == true || grant.praticiens.update == true || grant.praticiens.delete == true
      || grant.users.list == true || grant.users.create == true || grant.users.update == true || grant.users.delete == true
      || grant.log == true || grant.verify.list == true || grant.verify.check == true || grant.verify.create == true
      ){
      admin_menus = {
        header: "Administration",
        items: []
      }
    }
    if (grant.payments == true){
      admin_menus.items.push(
        {
          url: "/payments",
          name: "Paiements",
          slug: "payments",
          icon: "CreditCardIcon",
        }
      )
    }
    if (grant.validate == true){
      admin_menus.items.push(
        {
          url: "/payments/validate",
          name: "Validés",
          slug: "validate",
          icon: "CheckCircleIcon",
        }
      )
    }
    if (grant.verify.list == true || grant.verify.check == true || grant.verify.create == true){
      admin_menus.items.push(
        {
          url: "/payments/verify",
          name: "Vérification",
          slug: "verify",
          icon: "ShieldIcon",
        }
      )
    }
    if (grant.specialities.list == true
      || grant.specialities.create == true || grant.specialities.update == true || grant.specialities.delete == true){
      admin_menus.items.push(
        {
          url: "/specialities",
          name: "Spécialités",
          slug: "specialities",
          icon: "FolderIcon",
        }
      )
    }

    if (grant.praticiens.list == true || grant.praticiens.create == true
      || grant.praticiens.update == true || grant.praticiens.delete == true){
      admin_menus.items.push(
        {
          url: "/users/praticiens",
          name: "Praticiens",
          slug: "praticien",
          icon: "UsersIcon",
        }
      )
    }

    if (grant.users.list == true || grant.users.create == true
      || grant.users.update == true || grant.users.delete == true || grant.users.grant){
      admin_menus.items.push(
        {
          url: "/users",
          name: "Utilisateurs",
          slug: "users",
          icon: "UserIcon",
        }
      )
    }
    if (grant.log == true){
      admin_menus.items.push(
        {
          url: "/logs",
          name: "Logs",
          slug: "logs",
          icon: "ClockIcon",
        },
      )
    }
    menus.push(admin_menus)
    let second_menus = {}
    if (grant.statistics_payment == true || grant.chiffre == true){
      second_menus = {
        header: "STATISTIQUES",
        items: []
      }
    }
    if (grant.statistics_payment){
      second_menus.items.push({
        url: null,
        name: "Paiements",
        icon: "BarChart2Icon",
        submenu: [
          {
            url: "/statistics/to-validate",
            name: "A valider",
            slug: "to-validate",
            icon: "",
          },
          {
            url: "/statistics/is-validate",
            name: "Validés",
            slug: "is-validate",
            icon: "",
          },
          {
            url: "/statistics/to-canceled",
            name: "Annulés",
            slug: "to-canceled",
            icon: "",
          },
          {
            url: "/statistics/is-expired",
            name: "Expirés",
            slug: "is-expired",
            icon: "",
          },
        ],
      })
    }
    if (grant.chiffre == true){
      second_menus.items.push({
        url: null,
        name: "Chiffre d’affaires",
        icon: "TrendingUpIcon",
        submenu: [
          {
            url: "/statistics/with-specialities",
            name: "Par spécialité",
            slug: "with-specialities",
            icon: "",
          },
          {
            url: "/statistics/with-operator",
            name: "Par opérateur",
            slug: "with-operator",
            icon: "",
          }
        ],
      })
    }
    menus.push(second_menus)
    return menus
  }
}
